export default __webpack_public_path__ + "static/slide_1-6cfe6632e123e0c44bb3b6eabd4dbbc3.png";